export default __webpack_public_path__ + "ui/assets/img/calls-green-24.svg";